"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddStartingMaterialModal = AddStartingMaterialModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var pagination_1 = require("../../../constants/pagination");
var facility_1 = require("../../../features/apis/facility");
var seed_1 = require("../../../features/apis/seed");
var hooks_1 = require("../../../store/hooks");
var api_error_message_1 = require("../../../utils/api-error-message");
var paginated_content_1 = require("../../../utils/paginated-content");
var use_debounce_1 = require("../../../utils/use-debounce");
var loader_1 = require("../../loader");
var button_component_1 = require("../../ui/button-component");
var labeled_field_1 = require("../../ui/labeled-field");
var text_component_1 = require("../../ui/text-component");
/** Values match the seed types already stored in Firestore, so new batches group with the existing ones. */
var TYPE_OPTIONS = [
    { label: "Seeds", value: "Seeds" },
    { label: "Clones", value: "Clones" },
    { label: "Tissue Culture", value: "TissueCulture" },
];
var FACILITY_PAGE_SIZE = 30;
function AddStartingMaterialModal(props) {
    var _this = this;
    var _a, _b, _c;
    var isOpen = props.isOpen, clientId = props.clientId, onClose = props.onClose, onCreated = props.onCreated;
    var userId = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a._uid; });
    var _d = (0, react_2.useState)(""), batchName = _d[0], setBatchName = _d[1];
    var _e = (0, react_2.useState)(""), strain = _e[0], setStrain = _e[1];
    var _f = (0, react_2.useState)("Seeds"), type = _f[0], setType = _f[1];
    var _g = (0, react_2.useState)(""), quantity = _g[0], setQuantity = _g[1];
    var _h = (0, react_2.useState)(""), weight = _h[0], setWeight = _h[1];
    var _j = (0, react_2.useState)(""), facilityId = _j[0], setFacilityId = _j[1];
    var _k = (0, react_2.useState)(""), facilitySearch = _k[0], setFacilitySearch = _k[1];
    var _l = (0, react_2.useState)(pagination_1.DEFAULT_PAGE_NUMBER), facilityPage = _l[0], setFacilityPage = _l[1];
    var _m = (0, react_2.useState)([]), facilities = _m[0], setFacilities = _m[1];
    var _o = (0, react_2.useState)(""), error = _o[0], setError = _o[1];
    var _p = (0, react_2.useState)(false), isSubmitting = _p[0], setIsSubmitting = _p[1];
    var debouncedFacilitySearch = (0, use_debounce_1.useDebouncedValue)(facilitySearch);
    var _q = (0, facility_1.useGetFacilitiesQuery)({
        clientId: clientId,
        userId: userId !== null && userId !== void 0 ? userId : "",
        size: FACILITY_PAGE_SIZE,
        pageNumber: facilityPage,
        search: debouncedFacilitySearch || undefined,
    }, { skip: !isOpen || !clientId || !userId }), facilityData = _q.currentData, isLoadingFacilities = _q.isLoading, isFetchingFacilities = _q.isFetching;
    var canLoadMoreFacilities = (_c = (_b = (_a = facilityData === null || facilityData === void 0 ? void 0 : facilityData.content) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.hasNextPage) !== null && _c !== void 0 ? _c : false;
    var isLoadingMoreFacilities = isFetchingFacilities && facilityPage > pagination_1.DEFAULT_PAGE_NUMBER;
    (0, react_2.useEffect)(function () {
        setFacilityPage(pagination_1.DEFAULT_PAGE_NUMBER);
    }, [debouncedFacilitySearch, clientId]);
    (0, react_2.useEffect)(function () {
        var incomingFacilities = (0, paginated_content_1.getContentItems)(facilityData);
        if (facilityPage === pagination_1.DEFAULT_PAGE_NUMBER) {
            setFacilities(incomingFacilities);
            return;
        }
        setFacilities(function (currentFacilities) {
            var mergedById = new Map();
            currentFacilities.forEach(function (facility) { return mergedById.set(facility.id, facility); });
            incomingFacilities.forEach(function (facility) { return mergedById.set(facility.id, facility); });
            return Array.from(mergedById.values());
        });
    }, [facilityData, facilityPage]);
    var loadMoreFacilities = function () {
        if (!canLoadMoreFacilities || isFetchingFacilities) {
            return;
        }
        setFacilityPage(function (currentPage) { return currentPage + 1; });
    };
    var createSeed = (0, seed_1.useCreateSeedMutation)()[0];
    var requestTokenRef = (0, react_2.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    (0, react_2.useEffect)(function () {
        if (isOpen)
            return;
        setBatchName("");
        setStrain("");
        setType("Seeds");
        setQuantity("");
        setWeight("");
        setFacilityId("");
        setFacilitySearch("");
        setFacilityPage(pagination_1.DEFAULT_PAGE_NUMBER);
        setFacilities([]);
        setError("");
    }, [isOpen]);
    var closeNow = function () {
        requestTokenRef.current += 1;
        onClose();
    };
    var handleClose = function () {
        if (requestInFlightRef.current || isSubmitting) {
            return;
        }
        closeNow();
    };
    var parsedQuantity = Number(quantity);
    var parsedWeight = weight.trim() ? Number(weight) : undefined;
    var isQuantityValid = quantity.trim() !== "" && Number.isInteger(parsedQuantity) && parsedQuantity >= 0;
    var isWeightValid = parsedWeight === undefined || (Number.isFinite(parsedWeight) && parsedWeight >= 0);
    var canSubmit = !!batchName.trim() && !!strain.trim() && !!facilityId && isQuantityValid && isWeightValid;
    var handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, response, requestError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current || isSubmitting) {
                        return [2 /*return*/];
                    }
                    setError("");
                    if (!batchName.trim()) {
                        setError("Please enter a batch name.");
                        return [2 /*return*/];
                    }
                    if (!strain.trim()) {
                        setError("Please enter a strain.");
                        return [2 /*return*/];
                    }
                    if (!facilityId) {
                        setError("Please select a facility.");
                        return [2 /*return*/];
                    }
                    if (!isQuantityValid) {
                        setError("Please enter a quantity of zero or more.");
                        return [2 /*return*/];
                    }
                    if (!isWeightValid) {
                        setError("Please enter a weight of zero or more.");
                        return [2 /*return*/];
                    }
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, createSeed({
                            clientId: clientId,
                            batchName: batchName.trim(),
                            strain: strain.trim(),
                            type: type,
                            quantity: parsedQuantity,
                            startWeight: parsedWeight,
                            facilityId: facilityId,
                        }).unwrap()];
                case 2:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to add starting material. Please try again.");
                        return [2 /*return*/];
                    }
                    onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                    // Closes directly: handleClose is still blocked by the in-flight lock that `finally` has yet to release.
                    closeNow();
                    return [3 /*break*/, 5];
                case 3:
                    requestError_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Unable to add starting material. Please try again."));
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isSubmitting, isKeyboardDismissDisabled: isSubmitting, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[480px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isSubmitting, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "Add Starting Material" }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1 flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Batch Name", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Batch Name", value: batchName, onChange: setBatchName, isRequired: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "e.g. DEC1", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Strain", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Strain", value: strain, onChange: setStrain, isRequired: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Strain name", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Type", children: (0, jsx_runtime_1.jsxs)(react_1.Select, { "aria-label": "Type", selectedKey: type, onSelectionChange: function (key) { return key && setType(String(key)); }, children: [(0, jsx_runtime_1.jsxs)(react_1.Select.Trigger, { className: "rounded-md", children: [(0, jsx_runtime_1.jsx)(react_1.Select.Value, {}), (0, jsx_runtime_1.jsx)(react_1.Select.Indicator, {})] }), (0, jsx_runtime_1.jsx)(react_1.Select.Popover, { children: (0, jsx_runtime_1.jsx)(react_1.ListBox, { children: TYPE_OPTIONS.map(function (option) { return ((0, jsx_runtime_1.jsx)(react_1.ListBox.Item, { id: option.value, textValue: option.label, children: option.label }, option.value)); }) }) })] }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Quantity", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Quantity", value: quantity, onChange: setQuantity, isRequired: true, children: (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", min: 0, step: 1, placeholder: "0", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Weight", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Weight", value: weight, onChange: setWeight, children: (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", min: 0, step: "any", placeholder: "Optional", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "Facility", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "Search Facility", value: facilitySearch, onChange: setFacilitySearch, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Search facilities", className: "rounded-md" }) }), (0, jsx_runtime_1.jsxs)(react_1.Select, { "aria-label": "Facility", selectedKey: facilityId || null, onSelectionChange: function (key) { return key && setFacilityId(String(key)); }, isDisabled: isLoadingFacilities && facilities.length === 0, children: [(0, jsx_runtime_1.jsxs)(react_1.Select.Trigger, { className: "rounded-md", children: [(0, jsx_runtime_1.jsx)(react_1.Select.Value, {}), (0, jsx_runtime_1.jsx)(react_1.Select.Indicator, {})] }), (0, jsx_runtime_1.jsxs)(react_1.Select.Popover, { children: [(0, jsx_runtime_1.jsx)(react_1.ListBox, { children: facilities.map(function (facility) {
                                                                    var _a, _b;
                                                                    return ((0, jsx_runtime_1.jsx)(react_1.ListBox.Item, { id: facility.id, textValue: (_a = facility.name) !== null && _a !== void 0 ? _a : facility.id, children: (_b = facility.name) !== null && _b !== void 0 ? _b : facility.id }, facility.id));
                                                                }) }), isLoadingMoreFacilities && ((0, jsx_runtime_1.jsx)("div", { className: "border-t border-soft-gray px-4 py-2", children: (0, jsx_runtime_1.jsx)(loader_1.Loader, { variant: "inline", size: "sm", label: "Loading more facilities" }) }))] })] }), canLoadMoreFacilities && ((0, jsx_runtime_1.jsx)("div", { className: "flex justify-end", children: (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Load More Facilities", onPress: loadMoreFacilities, isPending: isLoadingMoreFacilities, variant: "secondary" }) }))] }) }), !isFetchingFacilities && facilities.length === 0 && ((0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: debouncedFacilitySearch ? "No facilities match your search." : "No facilities are available to you." })), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isSubmitting, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Add Starting Material", onPress: handleCreate, isPending: isSubmitting, isDisabled: !canSubmit, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
